import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AdminConst } from '../const';
import { CoreService } from '../../../core/header/core.service';
import { DummyComponent } from '../../../shared/dummy.component';
import { HelpService } from './help.service';
import { HelpModel } from '../../../shared/help/help.model';
import { AdminHelpDialogDeleteComponent } from './help-dialog-delete.component';

@Component({
    selector: 'convfact-adminhelp-list',
    templateUrl: './help-list.component.html',
    styleUrls: ['./help.component.css'],
    standalone: false
})

export class AdminHelpListComponent implements OnInit {

  constructor(
    private coreService: CoreService,
    private router: Router,
    public snackBar: MatSnackBar,
    private helpService: HelpService,
    public dialog: MatDialog,
    public dummy: DummyComponent
  ) { }

  headerTableHelp: any[] = AdminConst.headerTableHelp;

  helpList: HelpModel[] = [];
  ready = false;

  create(): void {
    this.router.navigate(['/admin/help/create']);
  }

  edit(uid: string): void {
    this.router.navigate(['/admin/help/edit/', uid]);
  }

  delete(uid: string) {
    this.dialog.open(AdminHelpDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url);
      }
      );
  }

  ngOnInit() {
    this.coreService.setName('Panel de ayuda');

    this.helpService.GetHelpList().then(result => {
      this.helpList = result;
      this.ready = true;
    }, error => {
      this.router.navigate(['/resume']);
    })

  }

}
